import {
  add_row_change_approvers,
  add_row_change_approvers_success,
  add_row_change_approvers_failure,
  add_row_change_approvers_idle,
  remove_row_change_approvers,
  remove_row_change_approvers_success,
  remove_row_change_approvers_failure,
  remove_row_change_approvers_idle,
  update_row_change_approvers,
  update_row_change_approvers_success,
  update_row_change_approvers_failure,
  update_row_change_approvers_idle,
  get_approvers_documents_by_approvers,
  get_approvers_documents_by_approvers_success,
  get_approvers_documents_by_approvers_failure,
  get_approvers_documents_by_approvers_idle,
  update_approvers_documents_by_approvers,
  update_approvers_documents_by_approvers_success,
  update_approvers_documents_by_approvers_failure,
  update_approvers_documents_by_approvers_idle,
} from "./actions";
import { handleActions } from "redux-actions";
import { combineReducers } from "redux";

const updateApproversDocumentsByApproversStatus = handleActions(
  {
    [update_approvers_documents_by_approvers_success.toString()]: (state, action) => {
      return "SUCCESS";
    },
    [update_approvers_documents_by_approvers_failure.toString()]: () => {
      return "FAILURE";
    },
    [update_approvers_documents_by_approvers.toString()]: () => {
      return "LOADING";
    },
    [update_approvers_documents_by_approvers_idle.toString()]: () => {
      return "IDLE";
    },
  },
  "IDLE"
);

const isApproversDocumentsByApprovers = handleActions<any, any>(
  {
    [get_approvers_documents_by_approvers_success.toString()]: (state, action) => {
      return action.payload;
    },
    [get_approvers_documents_by_approvers_idle.toString()]: () => {
      return false;
    },
    [get_approvers_documents_by_approvers_failure.toString()]: () => {
      return false;
    },
  }, 
  false
);

const getApproversDocumentsByApproversStatus = handleActions(
  {
    [get_approvers_documents_by_approvers_success.toString()]: () => {
      return "SUCCESS";
    },
    [get_approvers_documents_by_approvers_failure.toString()]: () => {
      return "FAILURE";
    },
    [get_approvers_documents_by_approvers.toString()]: () => {
      return "LOADING";
    },
    [get_approvers_documents_by_approvers_idle.toString()]: () => {
      return "IDLE";
    },
  },
  "IDLE"
);

const addStatus = handleActions(
  {
    [add_row_change_approvers_success.toString()]: () => {
      return "SUCCESS";
    },
    [add_row_change_approvers_failure.toString()]: () => {
      return "FAILURE";
    },
    [add_row_change_approvers.toString()]: () => {
      return "LOADING";
    },
    [add_row_change_approvers_idle.toString()]: () => {
      return "IDLE";
    },
  },
  "IDLE"
);

const removeStatus = handleActions(
  {
    [remove_row_change_approvers_success.toString()]: () => {
      return "SUCCESS";
    },
    [remove_row_change_approvers.toString()]: () => {
      return "LOADING";
    },
    [remove_row_change_approvers_idle.toString()]: () => {
      return "IDLE";
    },
    [remove_row_change_approvers_failure.toString()]: () => {
      return "FAILURE";
    },
  },
  "IDLE"
);

const updateStatus = handleActions(
  {
    [update_row_change_approvers_success.toString()]: () => {
      return "SUCCESS";
    },
    [update_row_change_approvers_failure.toString()]: () => {
      return "FAILURE";
    },
    [update_row_change_approvers.toString()]: () => {
      return "LOADING";
    },
    [update_row_change_approvers_idle.toString()]: () => {
      return "IDLE";
    },
  },
  "IDLE"
);

const changeApprovers = combineReducers({
  addStatus,
  removeStatus,
  updateStatus,
  getApproversDocumentsByApproversStatus,
  isApproversDocumentsByApprovers,
  updateApproversDocumentsByApproversStatus,
});

export { changeApprovers };